module.exports = __webpack_public_path__ + "static/media/descending_sort.301796a0.svg";